import GenericError from './generic-error';
export default GenericError;


// WEBPACK FOOTER //
// ./src/universal/components/generic-error/index.js